import React, { useEffect, useState } from 'react';
import { useAuth } from '../../auth/Auth';
import {
  getSpecialCountTime,
  getUpcomingTime,
  isCampMember,
} from '../../../utils/camp.utils';
import ZoomButton from './ZoomButton';
import Avatar from '../../../assets/images/my_room_active.svg';
import './css/camp.schedule.scss';
import Countdown, { zeroPad, formatTimeDelta } from 'react-countdown';
import { useHistory } from 'react-router-dom';
import { specialCampViewModel } from '../special_camp/special.camp.viewmodel';
import ZoomButtonSpecialCamp from './ZoomButtonSpecialCamp';
import {
  EXPERT_ROUTE,
  TREEHOUSE_ROUTE,
} from '../../../constants/routes.constants';
import EventEmitter from '../../../utils/events';

const CreatorCamp = (props) => {
  const { dependent, logout } = useAuth();
  const history = useHistory();
  const [specialCamp, setSpecialCamp] = useState();
  const [isCompleted, setIsCompleted] = useState(false);
  const [isSpecialCampShow, setIsSpecialCampShow] = useState(false);
  const group = dependent ? dependent.profile?.group : '';
  const campStatus = dependent ? dependent.profile?.camp_status : '';
  const [key, setKey] = useState(0);
  const isActive = isCampMember(campStatus);
  const [days, setDays] = useState(null);
  const [isPrompt, setIsPrompt] = useState(false);
  const [showCampJoin, setShowCampJoin] = useState(false);
  const zoomClassName = isActive
    ? 'camp-schedule-zoom-details'
    : 'camp-schedule-zoom-details-disabled';
  const getSchedule = () => {
    const convertedTime = getUpcomingTime(
      group.day,
      group.time,
      group.timezone
    );

    return `${convertedTime}`;
    // return getCampStatus(campStatus) || '';
  };

  const getSpecialCampSchedule = () => {
    const convertedTime = getSpecialCountTime(
      specialCamp.start_date_time,
      specialCamp.timezone
    );
    return convertedTime;
  };

  const countdownRendererSchool = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }) => {
    if (completed) {
      setShowCampJoin(true);
      return null;
    } else {
      setShowCampJoin(false);
      if (!isPrompt) {
        if (days > 0) {
          // EventEmitter.dispatch('show_prompt', {
          //   showPrompt: 'block',
          //   promptType: UPCOMING_CAMP_PROMPT,
          //   days: days
          // })
          setIsPrompt(true);
        } else {
          if (hours === 0) {
            // EventEmitter.dispatch('show_prompt', {
            //   showPrompt: 'block',
            //   promptType: UPCOMING_CAMP_30MINS_PROMPT,
            //   minutes: minutes
            // })
            setIsPrompt(true);
          }
        }
      }
      setDays(days);
      return (
        <h5 className="f-600" style={{ margin: 0 }}>
          <div class="countdown kid-commonroom-countdown">
            <div class="counts-days">
              <span id="days">{days}</span>
              <br />
              <span>Days</span>
            </div>
            <div class="counts-days">
              <span id="hrs">{zeroPad(hours)}</span>
              <br />
              <span>hrs</span>
            </div>
            <div class="counts-days">
              <span id="mins">{zeroPad(minutes)}</span>
              <br />
              <span>mins</span>
            </div>
            <div class="counts-days">
              <span id="secs">{zeroPad(seconds)}</span>
              <br />
              <span>secs</span>
            </div>
          </div>
        </h5>
      );
    }
  };

  const countdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      setIsCompleted(true);
      return null;
    } else {
      return (
        <span>
          {days}:{zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    }
  };

  const getSpecialCamps = () => {
    specialCampViewModel
      .getDependentSpecialCamp(dependent.special_camp?.special_camp_id)
      .then((res) => {
        setSpecialCamp(res);
        if (res && dependent.school_details) {
          if (
            Date.now() + getSchedule() <
            Date.now() + getSpecialCountTime(res.start_date_time, res.timezone)
          ) {
            setIsSpecialCampShow(true);
          }
        }
      })
      .catch((err) => {});
  };

  const handleSpecialCampClick = () => {
    if (specialCamp?.challenge?.treehouse_user?.id) {
      let id = specialCamp.challenge.treehouse_user.slug
        ? specialCamp.challenge.treehouse_user?.slug
        : specialCamp.challenge.treehouse_user?.id;
      history.push({
        pathname: `${
          specialCamp?.challenge?.treehouse_user?.type_of_organisation
            ? TREEHOUSE_ROUTE
            : EXPERT_ROUTE
        }/${id}`,
        state: {
          type: specialCamp.challenge.treehouse_user?.slug ? 'slug' : 'id',
        },
      });
    }
  };

  useEffect(() => {
    if (dependent.special_camp?.special_camp_id) {
      getSpecialCamps();
    }
  }, []);

  return (
    <>
      {/* <div className="camp-schedule-container creator-camp-box creator-camp-box-new justify-content-center text-center">
        {group?.id && !isSpecialCampShow &&
          <div className='inner-camp-box'>
            <div className='width-box'>
              <div className='kid-up-box' role='button' onClick={handleCampClick}>
                <div className='kid-up-name kid-center'>
                  <Image src={dependent.school_details?.tribe_picture ? dependent.school_details?.tribe_picture : Avatar} alt="" className='camp_img' width="50" />
                  <Image src={greenTick} alt="" className='green-tick' />
                </div>
                <div className={`group_name `}>
                  {group.name}
                </div>
              </div>
              <p className={`group_name `} onClick={handleCampClick}>Captain:&nbsp;
                <NavLink to="#">{group.group_captain ? group.group_captain?.first_name + ' ' + group.group_captain?.last_name : group.name}</NavLink></p>
              <span className='counter'>
                <Countdown
                  key={key}
                  date={Date.now() + Number(getSchedule())}
                  renderer={countdownRendererSchool}
                // overtime={true}
                // onComplete={handleComplete}
                />
              </span>
            </div>

            <div className="join-button px-3">
              {showCampJoin ?
                group?.meet_link ?
                  <ZoomButtonSpecialCamp title="Join Camp" link={group?.meet_link} /> :
                  group?.zoom_link ?
                    <ZoomButtonSpecialCamp title="Join Camp" link={group?.zoom_link} /> :
                    <ZoomButton title="Join Camp" creator={dependent} />
                : ''
              }
            </div>
            {showCampJoin ?
              !group.meet_link && group.zoom_link &&
              <>
                <Row
                  className={`p-3 justify-content-center camp-schedule-zoom-details`}
                  onClick={handleShowZoomModal}
                >
                  <Col className="col-auto">
                    <div className={`camp-schedule-details `}>
                      Check Meeting Id & Password &gt;
                    </div>
                  </Col>
                </Row>
                <ZoomModal showModal={showZoomModal} handleClose={handleCloseZoomModal} />
              </>
              : ''
            }
          </div>
        }
      </div> */}
      <>
        {showCampJoin ? (
          group?.meet_link ? (
            <ZoomButtonSpecialCamp
              isCommonRoom={true}
              title="Join Camp"
              link={group?.meet_link}
            />
          ) : group?.zoom_link ? (
            <ZoomButtonSpecialCamp
              isCommonRoom={true}
              title="Join Camp"
              link={group?.zoom_link}
            />
          ) : (
            <ZoomButton title="Join Camp" creator={dependent} />
          )
        ) : (
          <div className="width-box creator-camp-heading creators-heading-box">
            <span
              className="counter counter-new tribe-creators"
              style={{ height: 'auto', alignItems: 'center' }}
            >
              Camp starts in:
              <Countdown
                key={key}
                date={Date.now() + Number(getSchedule())}
                renderer={countdownRendererSchool}
                // overtime={true}
                // onComplete={handleComplete}
              />
            </span>
          </div>
        )}
      </>
    </>
  );
};

export default CreatorCamp;
